export default __webpack_public_path__ + "static/arity-thumbnail-3b6faa30c0c6629d83c1b10ce6037b5a.webp";